module.exports = __webpack_public_path__ + "img/isola.2ae8d5af.png";